import React from "react";
import { Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import { GET_FINANCIALS } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Downloads = () => {
  const [financials, setFinancials] = useState({});
  const [SidebarState, setSidebarState] = useState(false);
  const [loyaltyPoints, setloyaltyPoints] = useState(0);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = {
    id: encStorage.getItem("id"),
    name: encStorage.getItem("name"),
    client_code: encStorage.getItem("client_code"),
    id: encStorage.getItem("id"),
  };
  const fetchFinancials = async () => {
    const token = encStorage.getItem("token");
    //console.log(token);
    try {
      const response = await axios.post(
        GET_FINANCIALS,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFinancials(
        response.data.financials == null ? {} : response.data.financials
      );
    } catch (error) {
      setFinancials({});
      console.error("Error fetching financials:", error);
    }
  };
  useEffect(() => {
    fetchFinancials(); // Run on page load
    const interval = setInterval(fetchFinancials, 60000); // Run every 60 seconds
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <div className="container-fluid px-4">
            <div className="d-flex">
              <h3 className="mt-4 w-95">Downloads</h3>
            </div>
            <div className="card p-4">
              <div class="row">
                <div className="col-md-6 mb-2">
                  <h5>Android</h5>
                  <a
                    href="https://zedlytics.s3.me-central-1.amazonaws.com/markettrade.apk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                </div>
                <div className="col-md-6">
                  <h5>iOS</h5>
                  <a
                    href="https://apps.apple.com/jo/app/osense-trader/id6741929487"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download from App Store
                  </a>
                  <br />
                </div>
                <div className="col-md-6">
                  <h5>Windows</h5>
                  <a
                    href="https://zedlytics.s3.me-central-1.amazonaws.com/markettrade.exe"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                  <br />
                </div>
                <div className="col-md-6">
                  <h5>Web Login</h5>
                  <a
                    href="https://markettradeweb.theplatformapi.com/login"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Login to Web Platform
                  </a>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Downloads;
